import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface DepartmentMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allDepartmentMaster: [] | null | any;
}
const initialState: DepartmentMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allDepartmentMaster: null
};
export const departmentMasterSlice = createSlice({
  name: 'departmentMaster',
  initialState,
  reducers: {
    setAllDepartmentMaster: (state, action) => {
      state.allDepartmentMaster = action.payload.data;
    },
    setDepartmentMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllDepartmentMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllDepartmentMaster, setDepartmentMaster, setAllDepartmentMasterBySearch,reset } = departmentMasterSlice.actions;
export const allDepartmentMasterDetails = (state: RootState) => state.departmentMaster.allDepartmentMaster;
export const getAllDepartmentMasterDetails = (state: RootState) => state.departmentMaster.data;
export const getDepartmentMasterTotalRecords =(state:RootState)=>state.departmentMaster.totalRecords;
export const getAllDepartmentMasterBySearch = (state: RootState) => state.departmentMaster.data;
export default departmentMasterSlice.reducer;